<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let month;
  export let start;
  export let end;
  export let year;
  export let canIncrementMonth;
  export let canDecrementMonth;
  export let monthsOfYear;

  let monthSelectorOpen = false;
  let yearSelectorOpen = false;
  let availableMonths;
  let availableYears = [];

  $: {
    let isOnLowerBoundary = start.getFullYear() === year;
    let isOnUpperBoundary = end.getFullYear() === year;

    availableMonths = monthsOfYear.map((m, i) => {
      return Object.assign({}, {
        name: m[0],
        abbrev: m[1]
      }, {
        selectable:
          (!isOnLowerBoundary && !isOnUpperBoundary)
          || (
            (!isOnLowerBoundary || i >= start.getMonth())
            && (!isOnUpperBoundary || i <= end.getMonth())
          )
      });
    });
  }

  let startYear;
  let endYear;
  let startSelectYear;
  let endSelectYear;
  $: {
    availableYears.length = 0;
    startYear = start.getFullYear();
    endYear = end.getFullYear();
    startSelectYear = year - 4;
    endSelectYear = startSelectYear + 11;

    for (let y = startSelectYear; y <= endSelectYear; y++) {
      availableYears.push(
        {
          year: y,
          selectable: y >= startYear && y <= endYear
        }
      );
    }
  }

  let canDecrement = false;
  let canIncrement = false;
  let selectorTitle = monthsOfYear[month][0] + " " + year;
  $: {
    if (yearSelectorOpen) {
      canDecrement = startSelectYear > startYear;
    } else {
      canDecrement = canDecrementMonth;
    }

    if (yearSelectorOpen) {
      canIncrement = endSelectYear < endYear;
    } else {
      canIncrement = canIncrementMonth;
    }
 
    if (yearSelectorOpen) {
      selectorTitle = startSelectYear + " - " + endSelectYear;
    } else if (monthSelectorOpen) {
      selectorTitle = year + "";
    } else {
      selectorTitle = monthsOfYear[month][0] + " " + year;
    }
  }

  function toggleSelectorOpen() {
    if (monthSelectorOpen) {
      monthSelectorOpen = false;
      yearSelectorOpen = true;
    } else {
      yearSelectorOpen = false;
      monthSelectorOpen = true;
    }
  }

  function monthSelected(event, m) {
    event.stopPropagation();
    if (availableMonths[m].selectable) {
      dispatch('monthSelected', m);
      monthSelectorOpen = false;
      yearSelectorOpen = false;
    }
  }

  function yearSelected(event, y) {
    event.stopPropagation();
    if (y.selectable) {
      dispatch('yearSelected', y.year);
      monthSelectorOpen = true;
      yearSelectorOpen = false;
    }
  }

  function incrementSelector(direction) {
    if (yearSelectorOpen) {
      dispatch('incrementYear', direction);
    } else {
      dispatch('incrementMonth', direction);
    }
  }

</script>

<div class="title">
  <div class="heading-section">
    <div class="control" 
      class:enabled={canDecrement}
      on:click={() => canDecrement && incrementSelector(-1)}>
      <i class="arrow left"></i>
    </div>
    <div class="label" on:click={toggleSelectorOpen}>
      {selectorTitle}
    </div> 
    <div class="control"
      class:enabled={canIncrement}
      on:click={() => canIncrement && incrementSelector(1)}>
      <i class="arrow right"></i>
    </div>
  </div>
  <div class="selector" class:open={monthSelectorOpen}>
    {#each availableMonths as monthDefinition, index}
      <div 
        class="selector-item" 
        class:selected={index === month}
        class:selectable={monthDefinition.selectable}
        on:click={e => monthSelected(e, index)}
      >
        <span>{monthDefinition.abbrev}</span>
      </div>
    {/each}
  </div>
  <div class="selector" class:open={yearSelectorOpen}>
    {#each availableYears as yearDefinition, index}
      <div 
        class="selector-item" 
        class:selected={yearDefinition.year === year}
        class:selectable={yearDefinition.selectable}
        on:click={e => yearSelected(e, yearDefinition)}
      >
        {yearDefinition.year}
      </div>
    {/each}
  </div>
</div>


<style>
  .heading-section { 
    font-size: 20px;
    padding: 24px 15px;
    display: flex;
    justify-content: space-between;
    color: #3d4548;
    font-weight: bold;
  }
  .label { 
    cursor: pointer;
  }
  .selector { 
    position: absolute;
    top: 75px; 
    left: 0; 
    right: 0; 
    bottom: 0; 
    background-color: #fff;
    transition: all 300ms; 
    transform: scale(1.2); 
    opacity: 0; 
    visibility: hidden;
    z-index: 1;
    text-align: center;
  }
  .selector.open { 
    transform: scale(1); 
    visibility: visible;
    opacity: 1;
  }
  .selector-item { 
    width: 31.333%; 
    margin: .5%; 
    height: 23%;
    display: inline-block;
    color: #4a4a4a;
    border: 1px solid #efefef;
    opacity: 0.2;
  }
  .selector-item.selectable { 
    opacity: 1; 
  }
  .selector-item.selectable:hover { 
    cursor: pointer;
    box-shadow: 0px 0px 3px rgba(0,0,0,0.15);
  }
  .selector-item.selected { 
    background: var(--highlight-color);
    color: #fff;
  }
  .selector-item:before { 
    content: ' ';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  .selector-item span { 
    vertical-align: middle; 
    display: inline-block;
  }

  .control { 
    padding: 0 8px;
    opacity: 0.2;
    transform: translateY(3px);
  }

  .control.enabled { 
    opacity: 1; 
    cursor: pointer;
  }

  .arrow {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-style: solid;
    border-color: #a9a9a9;
    border-width: 0;
    border-bottom-width: 2px;
    border-right-width: 2px;
  }

  .arrow.right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .arrow.left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

</style>
